import React, { useEffect, useState } from 'react'
import { TriggerTooltip } from 'shared/ui/TriggerTooltip/TriggerTooltip'
import { Typography } from 'shared/ui'
import { type IMergeFieldConfig, MergeField } from 'widgets/MergeField'
import { getCaretCoordinates } from 'widgets/MessageField/lib/getCaretCoordinates'
import styles from './styles.module.scss'

export const useTriggerMergeFieldTooltip = ({
  textFieldElement,
  shortcut,
  config,
}: {
  textFieldElement: HTMLDivElement | null
  shortcut: string
  config: IMergeFieldConfig
}) => {
  const [mergeFieldCoordinates, setMergeFieldCoordinates] = useState<{
    x: number
    y: number
  } | null>(null)

  const closeMergeFieldTriggerTooltip = () => {
    setMergeFieldCoordinates(null)
  }

  useEffect(() => {
    if (textFieldElement) {
      const onKeyDown = (e: KeyboardEvent) => {
        if (e.key === shortcut) {
          setTimeout(() => {
            const coordinates = getCaretCoordinates()
            setMergeFieldCoordinates(coordinates)
          })
        } else {
          setMergeFieldCoordinates(null)
        }
      }

      textFieldElement.addEventListener('keydown', onKeyDown)
      return () => {
        textFieldElement.removeEventListener('keydown', onKeyDown)
      }
    }
  }, [textFieldElement])

  const info = (
    <div className={styles.shortcutInfo}>
      <Typography ariaLabel={'use'} variant={'body-md-regular'} color={'tertiary'}>
        Use
      </Typography>
      <Typography
        ariaLabel={'shortcut'}
        variant={'body-xs-medium'}
        color={'var(--content-primary-secondary)'}
        className={styles.shortcut}
      >
        {shortcut}
      </Typography>
      <Typography ariaLabel={'use'} variant={'body-md-regular'} color={'tertiary'}>
        to add access contact fields
      </Typography>
    </div>
  )

  return {
    triggerMergeFieldTooltip: (
      <TriggerTooltip
        placement={'bottom-start'}
        trigger={{
          getBoundingClientRect: () => {
            return new DOMRect(mergeFieldCoordinates?.x, (mergeFieldCoordinates?.y || 0) + 20, 0, 0)
          },
        }}
        open={!!mergeFieldCoordinates}
        component={
          <MergeField onCloseMenu={closeMergeFieldTriggerTooltip} isNoAutoFocus {...config} />
        }
        color={'white'}
        onClickAway={closeMergeFieldTriggerTooltip}
      />
    ),
    info,
  }
}
